import { ItemStatus } from '@nohara-dxdev/mt-common';

export const getStatusColor = (status: ItemStatus) => {
  switch (status.toLowerCase()) {
    case 'in-progress':
      return 'info';
    case 'specs-confirmed':
      return 'primary';
    case 'ordered':
      return 'warning';
    case 'installed':
      return 'success';
    case 'tested':
      return 'secondary';
    case 'locked':
      return 'error';
    default:
      return 'default';
  }
};
